<sh-seahorse-theme>
  <ca-sidebar *ngIf="isAppReady" sidebar></ca-sidebar>
  <ca-header *ngIf="isAppReady" header></ca-header>
</sh-seahorse-theme>
